/* ==========================================================================
   Option 3 — predictive search (session 16).

   The form is a real GET to /search and works with JS off. This upgrades it to live
   suggestions from Shopify's /search/suggest.json while the customer types.

   Money is formatted here rather than server-side because the suggest endpoint returns JSON,
   not Liquid. It mirrors snippets/gp-money.liquid exactly: whole EGP, Western digits,
   "EGP 450" in English and "450 ج.م" in Arabic.
   ========================================================================== */
(function () {
  'use strict';

  var panel = document.getElementById('gp-search');
  var input = document.getElementById('gp-search-input');
  var results = document.getElementById('gp-search-results');
  if (!panel || !input || !results) return;

  var isAr = document.documentElement.getAttribute('lang') === 'ar';
  var strings = window.gpSearchStrings || {};
  var timer = null;
  var lastQuery = '';
  var controller = null;

  // NOTE: /search/suggest.json returns price as a STRING IN MAJOR UNITS ("445.00") — unlike the
  // cart AJAX API, which returns cents. Dividing by 100 here turns EGP 445 into EGP 4.
  function money(amount) {
    var whole = Math.round(parseFloat(amount) || 0);
    var s = whole.toLocaleString('en-US'); // Western digits + separators in BOTH locales
    return isAr ? s + ' ج.م' : 'EGP ' + s;
  }

  function priceLabel(p) {
    var from = strings.from || 'From';
    var varies = p.price_min && p.price_max && p.price_min !== p.price_max;
    return varies ? from + ' ' + money(p.price_min) : money(p.price);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function open() {
    panel.hidden = false;
    document.querySelector('.gp-search-btn')?.setAttribute('aria-expanded', 'true');
    setTimeout(function () { input.focus(); }, 40);
  }

  function close() {
    panel.hidden = true;
    document.querySelector('.gp-search-btn')?.setAttribute('aria-expanded', 'false');
    results.innerHTML = '';
    input.value = '';
    lastQuery = '';
  }

  function render(products, query) {
    if (!products.length) {
      results.innerHTML =
        '<p class="gp-search-empty">' + (strings.empty || 'No products found') +
        ' “' + esc(query) + '”</p>';
      return;
    }
    var html = '<ul class="gp-search-list" role="list">';
    products.forEach(function (p) {
      // suggest.json exposes the thumbnail as `image` (a URL string), not `featured_image`
      var img = p.image
        ? '<img src="' + esc(p.image) + '" alt="" width="48" height="48" loading="lazy">'
        : '';
      html +=
        '<li class="gp-search-item">' +
          '<a href="' + esc(p.url) + '">' +
            '<span class="gp-search-thumb">' + img + '</span>' +
            '<span class="gp-search-meta">' +
              (p.type ? '<span class="prod-line">' + esc(p.type) + '</span>' : '') +
              '<span class="gp-search-name">' + esc(p.title) + '</span>' +
            '</span>' +
            '<span class="gp-search-price">' + priceLabel(p) + '</span>' +
          '</a>' +
        '</li>';
    });
    html += '</ul>';
    html +=
      '<a class="gp-search-all" href="' + (window.routes && window.routes.search_url || '/search') +
      '?q=' + encodeURIComponent(query) + '">' +
      (strings.view_all || 'See all results') + '</a>';
    results.innerHTML = html;
  }

  function suggestUrl(base, query) {
    return base + '.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
  }

  function search(query) {
    if (controller) controller.abort();
    controller = new AbortController();
    var signal = controller.signal;

    // On /ar the locale-prefixed endpoint (/ar/search/suggest) returns 417 "Unsupported buyer
    // locale" while Arabic is not attached to a Market. Rather than show the customer an empty
    // dropdown, fall back to the unprefixed endpoint — English titles beat no results. Once
    // Arabic is added to a Market the first call succeeds and the fallback never fires.
    var primary = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var fallback = '/search/suggest';

    function attempt(base, allowRetry) {
      return fetch(suggestUrl(base, query), { signal: signal })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, query);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          if (allowRetry && base !== fallback) return attempt(fallback, false);
          results.innerHTML = '<p class="gp-search-empty">' + (strings.error || 'Search is unavailable') + '</p>';
        });
    }

    attempt(primary, true);
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { results.innerHTML = ''; lastQuery = ''; return; }
    if (q === lastQuery) return;
    // debounce so a fast typist doesn't fire a request per keystroke
    timer = setTimeout(function () { lastQuery = q; search(q); }, 220);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-gp-search-open]')) {
      e.preventDefault();
      panel.hidden ? open() : close();
      return;
    }
    if (e.target.closest('[data-gp-search-close]')) {
      e.preventDefault();
      close();
      return;
    }
    // click outside the open panel closes it
    if (!panel.hidden && !e.target.closest('#gp-search') && !e.target.closest('[data-gp-search-open]')) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) close();
  });
})();
